import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import Pagination         from 'app/components/common/pagination';
import ScrollTable        from 'app/components/common/scroll-table';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/company-admin/forms';
import UiFormsDuck        from 'app/ducks/company-admin/ui-forms';
import formsHelpers       from 'app/helpers/forms';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';

class CadminPageFormsIndex extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  renderTable() {
    const {company, forms} = this.props;
    if (!forms) {
      return <Icon.Loading className="ca-box-loading" />;
    }

    return (
      <ScrollTable tableClassName="ca-box-table campaigns">
        <thead>
          <tr>
            <th>Title</th>
          </tr>
        </thead>
        <tbody>
          {(forms || []).map((form) => {
            const showPath = paths.cadminFormsShow(company.slug, form.id);
            const menu = (
              <EllipsisMenu usePortal>
                <Link href="#"><Icon.BrowserPageText />Employee View</Link>
                <Link href={showPath}><Icon.Cog1 />Manage</Link>
                <Link href={paths.cadminFormsEdit(company.slug, form.id)}><Icon.Pencil />Edit</Link>
              </EllipsisMenu>
            );
            return (
              <tr key={form.id}>
                <td>
                  <div className="menu-cell">
                    <Link className="pink-hover" href={showPath}>{form.title}</Link>
                    {menu}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </ScrollTable>
    );
  }

  render() {
    const {company, forms} = this.props;
    if (!company) return <PageLoading />;

    return (
      <CadminLayout className="ca-forms" company={company} activeItem="forms">
        <Meta title={`Forms | Millie`} />
        <div className="ca-main-head">
          <h1 className="ca-main-head-h1">Forms</h1>
          <div className="ca-main-head-actions">
            <Link href={paths.cadminFormsNew(company.slug)} className="btn blue">New Form</Link>
          </div>
        </div>

        <div className="ca-box">
          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Forms</h1>
            <div className="ca-box-header-controls"></div>
          </div>
          <div className="ca-box-body">
            {this.renderTable()}
          </div>
        </div>
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  forms: FormsDuck.Slx.allForms(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(CadminPageFormsIndex);
